import { type FormControlLabelProps, useRadioGroup } from '@mui/material';
import { StyledFormControlLabel } from './RadioButton.styles';

export const RadioButton = (props: FormControlLabelProps) => {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
        checked = radioGroup.value === props.value;
    }

    return <StyledFormControlLabel checked={checked} {...props} />;
};
